export default __webpack_public_path__ + "static/media/banner2.2a33ff1d.jpeg";